module.exports = __webpack_public_path__ + "img/launch_thumbnail-400x300.f5ec4f2c.jpg";